import React, { PropsWithChildren, useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { bindClose, bindToggle } from '@arema/components/Util';
import { CDN_ROOT } from './ReportsConfig';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { Dropdown } from 'semantic-ui-react';
import { Icon, Toast } from 'react-frontier';
import { TitleProvider } from '@arema/components/Hooks'
import { useUser } from './ReportHooks';
import { useTranslation } from 'react-i18next';
import API from './ReportsAPI';

import './style/header.scss';

interface MenuItem {
	text: string,
	access?: number[],
	href?: string,
	items?: MenuItem[],
	special?: boolean,
};

interface ComponentProps extends PropsWithChildren {
	outlet: JSX.Element
}

interface SidebarMenuProps {
	text: string,
	items: MenuItem['items']
}

var SidebarMenu = (props: SidebarMenuProps) => {
	var [shown, setShown] = useState<boolean>(false)

	return <div className="item dropdown">
		<div className="content" onClick={bindToggle(shown, setShown)}>
			<div className="text">{props.text}</div>
			<i className="dropdown icon"></i>
		</div>
		{shown ? (
			<div className="menu">
				{props.items.map(a => (
					<Link className={`item`} to={a.href} key={`hdrmenu-item-${a.href}`} replace>{a.text}</Link>
				))}
			</div>
		) : null}
	</div>
}

var Navigation = (props: ComponentProps) => {
	var { user } = useUser();
	var { t } = useTranslation();
	var [sidebar, setSidebar] = useState<boolean>(false);

	if(!user){
		return <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', backgroundColor: '#f0f0f0' }}>
			<img src={`${CDN_ROOT}/assets/logo/LogoG_Small.png`} alt="AREMA" style={{ borderRadius: 4 }} />
		</div>
	}

	const DEFAULT_MENU: MenuItem[] = [
		{ text: t('navbar.items.events'), href: '/', access: [] },
		// { text: t('navbar.items.edit'), href: '/editor', access: [] },
		// { text: t('navbar.items.callcenter'), href: '/callcenter', access: [] },
	]

	var menu = [];
	for(var i of DEFAULT_MENU){
		if(i.items){
			var items = [];
			for(var m of i.items){
				items.push(m);
			}
			if(items.length > 0){
				if(items.length == 1) menu.push(items[0])
				else menu.push({ text: i.text, items })
			}
		} else {
			menu.push(i);
		}
	}

	return <TitleProvider suffix={t('site')}>
		<Toast.Provider>
			<div style={{ backgroundColor: '#f7f7f7', minHeight: '100vh', position: 'relative' }}>
				<div className="ar menu">
					<div className="left">
						<div className="hamburger" onClick={bindToggle(sidebar, setSidebar)}>
							<i className="sidebar icon"></i>
						</div>
						<Link className="icon" to={'/'} replace>
							<img src={`${CDN_ROOT}/assets/logo/Logo_Small.png`} alt="Logo" />
						</Link>
						{menu.map(a => {
							if(a.items && a.items.length != 1){
								if(a.items.length == 0) return null;
								return <Dropdown className='item' text={a.text} key={`hdrmenu-drop-${a.text}`}>
									<Dropdown.Menu>
										{a.items.map(i => (
											<Dropdown.Item text={i.text} as={Link} to={i.href} key={`hdrmenu-item-${i.href}`} />
										))}
									</Dropdown.Menu>
								</Dropdown>
							} else {
								var item = a.items && a.items.length == 1 ? a.items[0] : a;
								return <Link className={`item`} to={item.href} key={`hdrmenu-item-${item.href}`} replace>{item.text}</Link>
							}
						})}
					</div>
					<div className="right">
						<Dropdown className='item' trigger={<>
							{!!user.admin_id && (
								<Icon name='user-shield' size={16} style={{ marginRight: 7 }} />
							)}
							{user?.first_name?.toUpperCase()}	
						</>}>
							<Dropdown.Menu>
								<Dropdown.Item text={t('navbar.items.account')} as={Link} to={'/profile'} />
								<Dropdown.Item text={t('navbar.items.password')} as={Link} to={'/profile/password'} />
								<Dropdown.Item text={t('navbar.items.logout')} onClick={API.logout} />
							</Dropdown.Menu>
						</Dropdown>
					</div>
				</div>
				<div className='ar site-container'>
					{props.outlet}
				</div>
				<TransitionGroup component={React.Fragment}>
					{!!sidebar && (
						<CSSTransition enter addEndListener={null} timeout={{ appear: 0, exit: 500 }}>
							<div className="ar menu-sidebar">
								{menu.map((a, i) => {
									if(a.items && a.items.length != 1){
										if(a.items.length == 0) return null;
										return <SidebarMenu text={a.text} items={a.items} key={`shdrmenu-drop-item-${i}`} />
									} else {
										var item = a.items && a.items.length == 1 ? a.items[0] : a;
										return <Link className='item' to={item.href} key={`shdrmenu-item-${item.href}`} replace={true}>{item.text}</Link>
									}
								})}
							</div>
						</CSSTransition>
					)}
					{!!sidebar && (
						<CSSTransition enter addEndListener={null} timeout={{ appear: 0, exit: 500 }}>
							<div className="ar sidebar-overlay" onClick={bindClose(setSidebar, false)}></div>
						</CSSTransition>
					)}
				</TransitionGroup>
			</div>
		</Toast.Provider>
	</TitleProvider>
}

export default Navigation;